


































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { storeHasilPenunjang } from "@/store/modules/HasilPenunjang";
import type {PenunjangLainResult} from "@/types/penunjang_result"
import { storePenunjang } from "@/store/modules/penunjang";

@Component({
  components: {}
})
export default class TableHasilRadiologiForResume extends Vue {
  @Prop() selectedId;
  @Prop() register;
  @Prop({ default: false, type: Boolean }) showSelect: boolean;
  @Prop({ default: false, type: Boolean }) showReload: boolean;
  @Prop({ default: "asc", type: Boolean }) sort: "asc" | "desc";

  tblHeight = "500";
  headers = [
    {
      text: "Tgl Hasil",
      align: "start",
      value: "tanggal",
      width: "10%"
    },
    { text: "Pemeriksan", value: "penunjang_lain_kategori.nama", width: "20%" },
    { text: "Unit", value: "unit.nama", width: "20%" },
    { text: "Catatan/ Hasil", value: "catatan", width: "50%" }
  ];

  selectedItem = [];

  @Watch("selectedItem")
  changedselectedItem(val) {
    this.$emit("selectedItem", val);
  }

  @Watch("selectedId")
  changedSelectedId(val: number[]) {
    this.selectedItem = this.renderedResultList.filter(item => {
      return val.includes(item.id);
    });
  }

  mounted() {}

  get rawResultListDummy(): PenunjangLainResult[] {
    return [
      {
        id: 1,
        tanggal: "2023-10-17",
        pasien: {
          rm: "60-60-60",
          nama: "NOOR HILAL FATHONI"
        },
        register_id: 23000005,
        waktu_periksa: "2023-10-17T03:12:04.000000Z",
        penunjang_lain_kategori: {
          id: "2",
          nama: "Echocardiography"
        },
        unit: {
          id: "27",
          nama: "Klinik Jantung"
        },
        catatan: "cor dalam kondisi baik\r\nirama normal\r\nkeseluruhan sehat",
        user: {
          id: "1",
          nama: "dr. Pakdhe Blangkon Sp.PD"
        },
        dokter: {
          id: "1",
          nama: "dr. Pakdhe Blangkon Sp.PD"
        },
        file: []
      },
      {
        id: 2,
        tanggal: "2023-10-17",
        pasien: {
          rm: "60-60-60",
          nama: "NOOR HILAL FATHONI"
        },
        register_id: 23000005,
        waktu_periksa: "2023-10-17T03:12:04.000000Z",
        penunjang_lain_kategori: {
          id: "1",
          nama: "USG"
        },
        unit: {
          id: "08",
          nama: "Klinik Kebidanan"
        },
        catatan:
          "Janin sehat\r\nterlilit tali pusar 2 kali",
        user: {
          id: "1",
          nama: "dr. Pakdhe Blangkon Sp.PD"
        },
        dokter: {
          id: "1",
          nama: "dr. Pakdhe Blangkon Sp.PD"
        },
        file: []
      }
    ];
  }

  get resultList(): PenunjangLainResult[] {
    return storePenunjang.penunjanglain;
      // return this.rawResultListDummy;
  }

  get renderedResultList() {
    return this.resultList.sort((a, b) => {
      return this.sort === "desc"
        ? new Date(b.waktu_periksa).getTime() - new Date(a.waktu_periksa).getTime()
        : new Date(a.waktu_periksa).getTime() - new Date(b.waktu_periksa).getTime();
    });
  }

  get loadingList() {
    return storeHasilPenunjang.loadingRadiologi;
  }

  edit(id) {
    this.$emit("edit", id);
  }

  remove(id) {
    this.$emit("remove", id);
  }

  reload() {
    storeHasilPenunjang.getRadiologiByRegister(this.register);
  }
}
